export default "/images/information-circle.svg?93e2116e3e79226760d3b7d1e5ef09e3";